<template>
  <v-app id="inspire">
    <v-main>
      <v-container
        class="fill-height"
        fluid>
        <v-row
          align="center"
          justify="center">
          <v-col
            cols="12"
            sm="8"
            md="4">
            <v-card class="elevation-12">
              <v-toolbar
                color="primary"
                dark
                flat>
                <v-toolbar-title>Camp Fulfillment Login</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation>
                  <v-text-field
                    v-model="username"
                    :rules="[v => !!v || 'Username is required']"
                    label="Username"
                    name="login"
                    type="text" />

                  <v-text-field
                    id="password"
                    v-model="password"
                    :rules="[v => !!v || 'Password is required']"
                    label="Password"
                    name="password"
                    type="password" />
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  dark
                  :loading="loading"
                  @click="login">
                  Login
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import AuthProvider from '@/resources/AuthProvider'
import { mapActions } from 'vuex'
import { setAuthUser, getAuth } from '@/utils/local-storage'
import BrandProvider from '@/resources/BrandProvider'
import employees from '@/utils/warehouse'
import humps from 'humps'
import menus from '@/utils/menu'

const brandService = new BrandProvider()

const authService = new AuthProvider()

export default {
  data () {
    return {
      valid: true,
      username: '',
      password: '',
      loading: false
    }
  },
  methods: {
    ...mapActions({
      setSnackBar: 'Style/setSnackbar',
      setWarehouse: 'Warehouse/setWarehose',
      setMenus: 'Menus/setMenus'
    }),
    validate () {
      this.$refs.form.validate()
    },
    async login () {
      await this.validate()
      if (!this.valid) {
        return
      }
      try {
        this.loading = true
        const { data } = await authService.login(this.username, this.password)
        setAuthUser(data)

        this.getBrandWarehouse()
        this.getMenusByRole()
        this.$router.push({ name: 'Home' })
        this.setSnackBar({
          value: true,
          message: 'Login Success',
          type: 'success'
        })
      } catch (err) {
        this.setSnackBar({
          value: true,
          message: 'Username หรือ Password ไม่ถูกต้อง',
          type: 'pink'
        })
      } finally {
        this.loading = false
      }
    },
    async getBrandWarehouse () {
      try {
        const { data } = await brandService.getBrandWarehouse()
        const auth = getAuth()
        if (auth.type === 'camp_employee') {
          this.setWarehouse(employees[auth.username].warehouses)
        } else if (auth.type === 'brand_owner') {
          this.setModal({
            value: true,
            title: 'ผิดพลาด',
            message: 'คุณไม่มีสิทธิ์เข้าถึงหน้านี้',
            confirmOnly: true,
            onConfirm: () => this.$router.push({ name: 'Login' })
          })
        } else {
          this.setWarehouse(humps.camelizeKeys(data))
        }
      } catch (error) {
        console.error(error)
      }
    },
    async getMenusByRole () {
      const auth = getAuth()
      if (auth.type === 'camp_online_admin' || auth.type === 'camp_owner') {
        this.setMenus(menus.all)
      } else {
        this.setMenus(menus.other)
      }
    }
  }
}
</script>
